import {
	FilterWithViewAll,
	Table,
	TableProps,
	TableWithActions,
} from '@/components';
import { MasterInfoEnum } from '@/constant';
import { ICommonApplicant } from '@/services';
import { memo } from 'react';

import {
	initialValuesFilter,
	MyFormikType,
	rowKey,
} from '../../define-assignment.config';
import { useLogic } from './applicant-list.logic';

export type ApplicantListProps = {
	formik: MyFormikType;
	fetchData: (params: any) => void;
	dateSourceAutomatic: ICommonApplicant[];
	fetchingAutomatic: boolean;
	applicantRowSelection: TableProps['rowSelection'];
} & TableProps;

const ApplicantList = (props: ApplicantListProps) => {
	const {
		filterRef,
		fetching,
		dataSource,
		total,
		reduxParams,
		columns,
		columnsApplicantSelected,
		onPageChange,
		handleTableChange,
	} = useLogic(props);

	return (
		<div>
			<div className="bg-white mt-[10px]">
				<div className="text-font2 font-bold text-[16px] leading-[20px] border-b p-5">
					근로자 선택
				</div>

				<div className="flex gap-x-[10px] px-5 pt-5">
					<FilterWithViewAll
						ref={filterRef}
						initialValues={initialValuesFilter}
						rowSelection={props.applicantRowSelection}
						fetchData={props.fetchData}
						inputName="fullName"
						inputPlaceholder="성/이름"
						inputClassName="!w-full min-w-[376px]"
						buttonClassName="w-[60px] min-w-0"
						hidePageSize
						labelSubmit="검색"
						isShowAutoComplete
						autoCompleteProps={{
							type: MasterInfoEnum.AUTOCOMPLETE_APPLICANT_NAME,
						}}
						hideCheckbox
					>
						<FilterWithViewAll.CheckboxFilter
							name="assignmentPossibility"
							containerClassName="w-[108px]"
							suffixLabel="배정가능"
							suffixLabelClassName="min-0 w-max"
						/>
					</FilterWithViewAll>
				</div>
				<TableWithActions
					columns={columns}
					loading={fetching}
					dataSource={dataSource}
					actionHidden
					onPageChange={onPageChange}
					pagination={{
						defaultPageSize: reduxParams?.pageSize,
						current: reduxParams?.page,
						pageSize: reduxParams?.pageSize,
						total,
					}}
					rowKey={rowKey}
					defaultPageSize={reduxParams?.pageSize}
					rowClassName={(record: ICommonApplicant) => {
						return record?.disabled
							? 'bg-gray4 [&>.ant-table-cell-row-hover]:!bg-gray4'
							: '';
					}}
					rowSelection={props.applicantRowSelection}
					onChange={handleTableChange}
					isSearching={filterRef?.current?.isSearching}
					containerClassName="px-5"
				/>
			</div>

			<div className="bg-white mt-[10px]">
				<h2 className="text-font2 font-bold text-[16px] leading-[20px] border-b p-5">
					선택 된 근로자
				</h2>

				<Table
					loading={props.fetchingAutomatic}
					columns={columnsApplicantSelected}
					dataSource={props.rowSelection?.selectedRows}
					rowSelection={{
						...props.rowSelection,
						hideSelectAll: true,
					}}
					rowClassName={(record: ICommonApplicant) => {
						return record?.hasError
							? '[&>.ant-table-cell]:!bg-red-100 [&>.ant-table-cell-row-hover]:!bg-red-100'
							: '';
					}}
					pagination={false}
					scroll={{ y: 435 }}
					rowKey={rowKey}
					className="p-5"
				/>
			</div>
		</div>
	);
};

export default memo(ApplicantList);
